export default {
    MSG_TYPE_SUCCESS: 'SUCCESS',
    MSG_TYPE_INFO: 'INFO',
    MSG_TYPE_WARNING: 'WARNING',
    MSG_TYPE_ERROR: 'ERROR',
}